import 'reflect-metadata';
import { Column, Entity, JoinTable, ManyToMany, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, EntiteStatique, Activite } from '.';

@EntiteStatique()
@Entity('langue')
export class Langue implements BaseEntite {
    static key = 'langues';
    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;

    @ManyToMany(() => Activite, (activite: Activite) => activite.langues)
    @JoinTable({
        name: 'langue_activite',
        inverseJoinColumn: {
            name: 'fk_id_activite',
            referencedColumnName: 'id',
        },
        joinColumn: {
            name: 'fk_id_langue',
            referencedColumnName: 'id',
        },
    })
    activites: Activite[];
}
